





















































































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import TokenUtil from "@/utils/TokenUtil";
import AuthModule from "@/store/auth";
import AdminsApi from "@/services/AdminsApi";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MDashboard extends CheckAdminLogin {
  // 削除ダイアログ
  private dialogDelete = false;

  // アカウント削除確認チェックボックス
  private checkbox = false;

  // Yesチェックボックスのオンオフの取得
  private get check() {
    return this.checkbox;
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // アカウント削除が押されたとき
  private async deleteAccount() {
    // アカウント削除確認チェックボックスのチェックを外す
    this.checkbox = false;
    // 削除ダイアログを表示
    this.dialogDelete = true;
  }

  // okがクリックされたとき
  private async deleteItemCfm() {
    if (!this.me) {
      return;
    }
    try {
      await AdminsApi.instance.deleteAdminByUuid(this.me.uuid);
      // アカウント削除と同時にログアウトしトップページに戻る
      this.logout();
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  private closeDelete() {
    // 削除ダイアログ オフ
    this.dialogDelete = false;
  }

  // ログアウト処理
  private logout() {
    TokenUtil.removeToken();
    AuthModule.commitMe(null);
    // ログアウトと同時にトップページに戻る
    this.$router.push("/");
  }
}
